<mat-accordion [multi]="true">
    <aumico-title-translations
        [tableData]="notesTypeTitle"
        [selectedLocale]="selectedLocale"
        (translationValuesChanged)="onTitleValueChanged($event)"
    ></aumico-title-translations>
    <aumico-notes-edit-notes-type-rich-text-translations
        [richTexts]="notesTypeInformation"
        [selectedLocale]="selectedLocale"
        [rowName]="'Information'"
        (translationValuesChanged)="onInformationValuesChanged($event)"
    ></aumico-notes-edit-notes-type-rich-text-translations>
    <div *ngFor="let component of notesType.componentsOptions">
        <mat-expansion-panel [expanded]="panelOpenState">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ component.componentName }}</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container [ngSwitch]="component.componentName">
                <div *ngSwitchCase="componentNames.EQUITY">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="equityOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onEquityComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
                <div *ngSwitchCase="componentNames.RICH_TEXT">
                    <aumico-notes-edit-notes-type-rich-text-translations
                        [richTexts]="richTextTitles"
                        [selectedLocale]="selectedLocale"
                        rowName="Title"
                        (translationValuesChanged)="onRichTextTitleValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-rich-text-translations>
                    <aumico-notes-edit-notes-type-rich-text-translations
                        [richTexts]="richTextOptions"
                        [selectedLocale]="selectedLocale"
                        rowName="Text"
                        (translationValuesChanged)="onRichTextComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-rich-text-translations>
                </div>
                <div *ngSwitchCase="componentNames.MOVEMENT_SCHEDULE">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="movementScheduleOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onMovementScheduleComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
                <div *ngSwitchCase="componentNames.FINANCIAL_LINE_ITEM">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="financialLineItemOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onFinancialLineItemComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
                <div *ngSwitchCase="componentNames.SELECT">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="selectOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onSelectComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
                <div *ngSwitchCase="componentNames.INPUT">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="inputOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onInputComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
                <div *ngSwitchCase="componentNames.SUPER_TABLE">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="superTableOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onSuperTableComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
                <div *ngSwitchCase="componentNames.FREE_TABLE_WITH_AMOUNTS">
                    <aumico-notes-edit-notes-type-components-translations
                        [tableData]="freeTableOptions"
                        [selectedLocale]="selectedLocale"
                        (translationValuesChanged)="onFreeTableComponentValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-components-translations>
                </div>
            </ng-container>
        </mat-expansion-panel>
    </div>
</mat-accordion>
